import { render, staticRenderFns } from "./Investors.vue?vue&type=template&id=04eeb19c&scoped=true&"
import script from "./Investors.vue?vue&type=script&lang=js&"
export * from "./Investors.vue?vue&type=script&lang=js&"
import style0 from "./Investors.vue?vue&type=style&index=0&id=04eeb19c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eeb19c",
  null
  
)

component.options.__file = "Investors.vue"
export default component.exports